// extracted by mini-css-extract-plugin
export var image = "_ip-0";